define('app/visualizations/LineChart',['require','./SimpleCategoricalChartView'],function(require) {
	'use strict';

	var SimpleCategoricalChartView = require('./SimpleCategoricalChartView');

	return SimpleCategoricalChartView.extend({
		type: 'line'
	});
});

